import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from './theme';
import { AuthProvider } from './context/AuthContext';
import { AppProvider } from './AppContextDef';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <ThemeProvider theme={theme}>
    <CssBaseline />
    <AuthProvider>
      <AppProvider>
    <App />
    </AppProvider>
    </AuthProvider>
    </ThemeProvider>
  //  </React.StrictMode>
);